const EmptyBillList = () => {
  return (
    <div className="d-flex flex-column align-items-center py-6 px-20">
      <i className="bi bi-file-earmark-text fs-5x mb-5" />
      <h3 className="mb-6 text-gray-800">Contas</h3>
      <span className="mb-10 text-gray-700">Lista vazia. Nenhuma conta encontrada.</span>
    </div>
  );
};

export default EmptyBillList;
